<div class="container">
  <div class="row">
    <div class="col-12">
      <img src="assets/resources/resume_img.png" class="img-fluid sticker-resume" alt="photo">
      <div class="resume-header text-center" translate>Resume</div>
    </div>
  </div>
  <div class="col-12">
    <div class="resume-text text-center" translate>
      ResumeInfo
    </div>
  </div>
<div class="row">
  <div class="d-none d-md-flex col-4">
  </div>

  <!--  EDUCATION-->
  <div class="col-12 col-md-4 ">
  <div class="text-center mt-5">
    <span class="resume-header-small" translate>Education</span>
    <div class="resume-text-small-title" translate>
      JavaProgrammingCourse
    </div>
    <div class="resume-text-small">
      Software Development Academy
    </div>
    <div class="resume-text-small-footer">
      06.2021 - 04.2021
    </div>
  </div>

  <!--  WORK EXPERIENCE-->
  <div class="text-center mt-5">
    <span class="resume-header-small" translate>WorkExp</span>
    <div class="resume-text-small-title">
      Software Engineer
    </div>
    <div class="resume-text-small">
      Acoustic Marketing
    </div>
    <div class="resume-text-small-footer" translate>
      AcousticWorkPeriodMid
    </div>
    <div class="resume-text-small-title">
      Associate Software Engineer
    </div>
    <div class="resume-text-small">
      Acoustic Marketing
    </div>
    <div class="resume-text-small-footer" translate>
      AcousticWorkPeriodJunior
    </div>
    <div class="resume-text-small-title">
      Associate developer
    </div>
    <div class="resume-text-small">
      Sapiens Software Solutions
    </div>
    <div class="resume-text-small-footer" translate>
      SapiensWorkPeriod
    </div>
  </div>
  </div>
  <div class="d-none d-md-flex col-4 align-items-center">
    <img src="assets/resources/circle-cropped.png"style="max-width: 13rem; max-height: 13rem" alt="photo">
  </div>

</div>

  <!--  SKILLS-->
  <div class="col-12 text-center mt-5">
    <span class="resume-header-small" translate>SkillsAndTools</span>
    <div class="row resume-text-small mt-4">
      <div class="col-12 col-md-4">
        <div class="m-1">Java 8+</div>
        <div class="m-1">Python (basic)</div>
        <div class="m-1">Node.JS (basic)</div>
        <div class="m-1">Spring Boot</div>
        <div class="m-1">Hibernate</div>
        <div class="m-1">SQL databases (mySQL, MS SQL, Oracle)</div>
        <div class="m-1">MongoDB</div>
      </div>

      <div class="col-12 col-md-4">
        <div class="m-1">Jenkins</div>
        <div class="m-1">Unit Testing</div>
        <div class="m-1">TDD</div>
        <div class="m-1">JUnit</div>
        <div class="m-1">AssertJ</div>
        <div class="m-1">Mockito</div>
        <div class="m-1">Docker</div>
        <div class="m-1">Kubernetes</div>
      </div>

      <div class="col-12 col-md-4">
        <div class="m-1">Gradle, Maven</div>
        <div class="m-1">Version Control System, Git</div>
        <div class="m-1">REST APIs</div>
        <div class="m-1">GraphQL</div>
        <div class="m-1">API design</div>
        <div class="m-1">Design Patterns</div>
        <div class="m-1">Object-oriented design</div>
      </div>
    </div>

    <div class="resume-text-small-title mt-5" translate>
      DownloadCV
    </div>
    <a href="assets/download/Kamil Kukowski - CV - ENG.pdf" download class="btn bg-black lift mt-3 resume-button" translate>
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-download mr-3" viewBox="0 0 16 16">
        <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"/>
        <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"/>
      </svg>
      Download</a>
  </div>


</div>
